export default __webpack_public_path__ + "static/media/supervet.15bba626.png";